import styled from "styled-components";

const Title = styled.h1`
    font-weight: 700;
    font-size: 2rem;
    margin: 1rem;
`;

export default Title;
